module.exports = __webpack_public_path__ + "static/media/newabout_3.0d12bc46.png";